import React from 'react'
import { useTranslation } from 'react-i18next'
import { Grid, withStyles } from '@material-ui/core'
import { Label } from '../../default'
import { CardFilter } from '../../cards'
import TableFilter from './TableFilter'

const PanelFilter = ({ classes }) => {

  const { t } = useTranslation()

  return (
    <Grid container spacing={3} className={classes.root}>
      <Grid item xs={12}>
        <Label v='h5' bold>{t('panels.filters.title')}</Label>
      </Grid>
      <Grid item xs={12}>
        <CardFilter />
      </Grid>
      <Grid item xs={12}>
        <TableFilter />
      </Grid>
    </Grid>
  )
}

const styles = theme => ({
  root: {
    display: 'flex',
    flex: 1
  }
})

export default withStyles(styles)(PanelFilter)